import { render, staticRenderFns } from "./vehiculosSeccion.vue?vue&type=template&id=796779a3&scoped=true"
import script from "./vehiculosSeccion.vue?vue&type=script&lang=js"
export * from "./vehiculosSeccion.vue?vue&type=script&lang=js"
import style0 from "./vehiculosSeccion.vue?vue&type=style&index=0&id=796779a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796779a3",
  null
  
)

export default component.exports